import { Action, createReducer, on } from '@ngrx/store';

import {
  OutputSettings,
  OutputSettingsList,
} from '../models/output-settings.models';

import {
  loadOutputSettings,
  saveOutputSettings,
  loadOutputSettingsSuccess,
  saveOutputSettingsSuccess,
  fetchOutputSettingsRecordSuccess,
} from '../actions/output-settings.actions';

import { produce } from 'immer';

export interface OutputSettingsState {
  outputSettings: OutputSettingsList[]; // loaded only basic output settings
  outputSettingsRecords: OutputSettings[]; // fully loaded output settings
  loading: boolean;
  saving: boolean;
}

export const initialState: OutputSettingsState = {
  outputSettings: [],
  outputSettingsRecords: [],
  loading: false,
  saving: false,
};

const _outputSettingsReducer = createReducer(
  initialState,
  on(loadOutputSettings, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),

  on(loadOutputSettingsSuccess, (state, { outputSettings }) => {
    return {
      ...state,
      loading: false,
      outputSettings: outputSettings,
    };
  }),

  on(saveOutputSettings, (state) => {
    return {
      ...state,
      saving: true,
    };
  }),

  on(
    saveOutputSettingsSuccess,
    produce((draft, { outputSettings }) => {
      const index = draft.outputSettingsRecords.findIndex(
        (os) => os.id === outputSettings.id,
      );

      if (index === -1) {
        draft.outputSettingsRecords.push(outputSettings);
      } else {
        draft.outputSettingsRecords[index] = outputSettings;
      }

      // * Also update outputSettings (basic list for dropdowns)
      const basicInfo: OutputSettingsList = {
        id: outputSettings.id,
        company_id: outputSettings.company_id,
        title: outputSettings.title,
        description: outputSettings.description,
        output_settings_type: outputSettings.output_settings_type,
        count_used: 0, // ? default value for new/updated settings
      };

      const listIndex = draft.outputSettings.findIndex(
        (os) => os.id === outputSettings.id,
      );

      if (listIndex === -1) {
        draft.outputSettings.push(basicInfo);
      } else {
        draft.outputSettings[listIndex] = basicInfo;
      }

      draft.saving = false;
    }),
  ),

  on(
    fetchOutputSettingsRecordSuccess,
    produce((draft, { outputSettings }) => {
      const idx = draft.outputSettingsRecords.findIndex(
        (r) => r.id === outputSettings.id,
      );

      if (idx === -1) {
        draft.outputSettingsRecords.push(outputSettings);
      } else {
        draft.outputSettingsRecords[idx] = outputSettings;
      }
    }),
  ),
);

export function outputSettingsReducer(
  state: OutputSettingsState,
  action: Action,
) {
  return _outputSettingsReducer(state, action);
}
